<template>
	<li>
		<button type="button" class="uk-accordion-title">2. Sofa Fabric</button>
		<div class="uk-accordion-content">
			<div class="wood-type-container section-overflow" tabindex="0" role="region" aria-label="Sofa fabrics">
				<div class="uk-child-width-1-3@s uk-grid-small uk-child-width-1-2" uk-grid>
					<div v-for="fabric in sofa_fabrics" :key="'fabric_'+fabric.id">
						<button type="button" class="wood-type" :class="{'selected' : isActive(fabric)}" role="radio" :aria-checked="isActive(fabric) ? 'true' : 'false'" :aria-label="`${fabric.name} fabric`" @click.prevent="onClick(fabric)">
							<img :src="imgStyle(fabric)" alt="">
							<p class="name">{{ fabric.name }} </p>
						</button>
					</div>
				</div>
			</div>
		</div>
	</li>
</template>

<script>

import {mapState} from "vuex";

export default {
	name: "",

	props: {
		dataFailure: {
			type: Boolean,
			default: false
		},
		colorOnly: {
			type: Boolean,
			default: false
		}
	},
	components: {},
	data() {
		return {
			
		}
	},
	mounted() {

	},
	methods: {
		/**
		 * Generates a formatted image URL path based on the provided fabric object.
		 *
		 * @param {Object} fabric - The fabric object that may contain image data.
		 * @return {string} A formatted image URL path if fabric and fabric.image are provided; otherwise, an empty string.
		 */
		imgStyle(fabric) {
			if(fabric && fabric.image){
				return `${fabric.image.webPath}/160`;
			}
			return '';
		},
		/**
		 * Handles the click event and commits the selected fabric to the store.
		 *
		 * @param {string} selectedFabric - The fabric selected by the user.
		 * @return {void} Does not return a value.
		 */
		onClick(selectedFabric) {
			this.$store.commit('setSelectedSofaFabric', selectedFabric);
		},
		/**
		 * Determines whether the provided fabric is the currently selected fabric.
		 *
		 * @param {Object} fabric - The fabric object to check.
		 * @return {boolean} Returns true if the given fabric matches the selected fabric, otherwise false.
		 */
		isActive(fabric) {
			if (this.selected_fabric == null) return false;
			return this.selected_fabric.id == fabric.id;
		},
	},
	computed: {
		...mapState({
			selected_size: state => state.selected_size,
			bed_sizes: state => state.bed_sizes,
			sofa_fabrics: state => state.sofa_fabrics,
			selected_fabric: state => state.selected_fabric,
			price_totals: state => state.totals,
			useDiscounts: state => state.useDiscounts
		})
	},
	watch: {
	}
}
</script>